import React from 'react';
import {
  Grid,
  TextField,
} from '@mui/material';

// Recibe onFieldChange(value, fieldName)
function AgentFormBasicInfo({ 
  agentId, 
  project, 
  description, 
  errors, 
  onFieldChange // Renombrado de handleInputChange a onFieldChange
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <TextField
          label="Agent ID"
          fullWidth
          value={agentId}
          // Usar onFieldChange con la firma correcta
          onChange={(e) => onFieldChange(e.target.value, 'agentId')}
          required
          error={!!errors.agentId}
          helperText={errors.agentId || ''}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Proyecto"
          fullWidth
          value={project}
          onChange={(e) => onFieldChange(e.target.value, 'project')}
          required
          error={!!errors.project}
          helperText={errors.project || "Por defecto: 'default'"}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Descripción"
          multiline
          rows={2}
          fullWidth
          value={description}
          onChange={(e) => onFieldChange(e.target.value, 'description')}
          required
          error={!!errors.description}
          helperText={errors.description || ''}
        />
      </Grid>
    </Grid>
  );
}

export default AgentFormBasicInfo; 